import { render, staticRenderFns } from "./CardRequest.vue?vue&type=template&id=05659cf4"
import script from "./CardRequest.vue?vue&type=script&lang=js"
export * from "./CardRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports